'use client';
import { useContext } from 'react';

import cx from 'classnames';

import styles from './CardLogo.module.scss';
import { CarouselContext } from '../../carousel/CarouselContext';
import { Logo } from '../../logo';

export const CardLogo = ({ randomSeed }: { randomSeed: string }) => {
  const isInCarousel = useContext(CarouselContext);

  return (
    <>
      {!isInCarousel && <Logo randomSeed={randomSeed} className={styles.seededLogo} />}
      {isInCarousel && (
        <>
          {/* if cards are in a Carousel, the other variants will be shown in a cycle via CSS */}
          <Logo variant="pristine" className={cx(styles.carouselLogo, styles.pristine)} />
          <Logo variant="reverential" className={cx(styles.carouselLogo, styles.reverential)} />
          <Logo variant="empowering" className={cx(styles.carouselLogo, styles.empowering)} />
          <Logo variant="dynamic" className={cx(styles.carouselLogo, styles.dynamic)} />
        </>
      )}
    </>
  );
};
